import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsmedia',
	templateUrl:'./BSMediaPage.html',
	styles: [],
	styleUrls:['./BSMediaPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSMediaPage
{
	mdContent_124 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.media.BSMedia;
\`\`\``;
	mdContent_125 = `\`\`\`java
new BSMedia<>()
\`\`\``;
	mdContent_126 = `\`\`\`java
var media = new BSMedia<>();
var img = new BSImage<>("/images/avatar.jpg");
media.add(img);
var body = new Div<>();
body.setText("Media body content here.");
media.add(body);
\`\`\``;
}
